<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPin_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M8.29 10.912a6.937 6.937 0 0 0-1.24.845C5.737 12.883 5 14.41 5 16h6v5a1 1 0 1 0 2 0v-5h6c0-1.591-.738-3.117-2.05-4.243a6.937 6.937 0 0 0-1.24-.845L14.754 4H17a1 1 0 1 0 0-2H7a1 1 0 0 0 0 2h2.247l-.958 6.912Z"
        clip-rule="evenodd"
    />
</svg>
